import Head from 'next/head';
import Homepage from '../src/Components/merchants/merchants';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

export default function Home(props) {
  const router = useRouter();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (localStorage.getItem('token')) setLoading(false);
    else router.push('/login');
  }, []);

  return loading ? null : (
    <div className='main-content'>
      <Head>
        <title>Merchants</title>
        <link rel='icon' href='/favicon.svg' />
        <meta content='width=1024, initial-scale=1.0; ' name='viewport' />
      </Head>
      <Homepage {...props} />
    </div>
  );
}
